module.exports = __webpack_public_path__ + "img/cloud_empty.8ca72dd5.png";